import styled, { ITheme } from '../../../../../theme'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'

const Label = styled.div<IWithSize>`
  font-family: Montserrat;
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(props: ITheme) => props.theme.colors.palette.slateGrey};
`

export default Label
